import React, { useContext, useEffect, useLayoutEffect, useState } from "react";

import { NextUIProvider, Tab, Tabs } from "@nextui-org/react";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";

import {
  RouterProvider,
  createBrowserRouter,
  useNavigate,
  Navigate,
} from "react-router-dom";
import Layout from "components/Layout/Layout";

import Login from "components/Login/Login";
import Register from "components/Register/Register";
import Homepage from "pages/Homepage/Homepage";
import ForgetPassword from "components/ForgetPassword/ForgetPassword";
import VerifyPassword from "components/VerifyPassword/VerifyPassword";
import ProtectedLogin from "components/ProtectedRoutes/ProtectedLogin";
import ProtectedVerify from "components/ProtectedRoutes/ProtectedVerify";
import { AuthContext } from "Context/AuthContext";
import ProtectedRoutes from "components/ProtectedRoutes/ProtectedRoutes";
import AuthHomePage from "components/AuthHomePage/AuthHomePage";
import Download from "components/Download/Download";
import ContactUs from "components/ContactUs/ContactUs";
import FAQ from "components/FAQ/FAQ";
import HomeComponent from "components/Tour/HomeComponent";
import AuthLayout from "components/AuthLayout/AuthLayout";
import MyFronds from "MyFronds/MyFronds";
import SharedFronds from "components/SharedFronds/SharedFronds";
import Invitations from "components/Invitations/Invitations";
import ArchiveFronds from "components/ArchiveFronds/ArchiveFronds";
import CreateFrond from "pages/CreateAFrond/CreateFrond";
import Blog from "components/Blog/Blog";
import BlogPost from "components/Blog/BlogPost";
import AdminBlogManage from "components/Blog/AdminBlogManage";
import AdminCreatePost from "components/Blog/AdminCreatePost";
import { useAuth, useClerk, useUser } from "@clerk/clerk-react";
import axios from "axios";
import Error404 from "pages/Error404/Error404";
import Error500 from "pages/Error500/Error500";
import CallbackAuth from "components/CallbackAuth/CallbackAuth";
import MainLoader from "pages/MainLoader/MainLoader";
import ResetPassword from "components/ResetPassword/ResetPassword";
import ProtectedReset from "components/ProtectedRoutes/ProtectedReset";
import ProtectedError from "components/ProtectedRoutes/ProtectedError";
import { Error500Context } from "Context/Error500Context";
import AboutFrondDetails from "components/FrondDetails/AboutFrondDetails";
import ScrapbookImages from "components/FrondDetails/Scrapbook/ScrapbookImages";
import DetailsTemplate from "components/FrondDetails/DetailsTemplate";
import ScrapbookTemplate from "components/FrondDetails/Scrapbook/ScrapbookTemplate";
import ScrapbookNotes from "components/FrondDetails/Scrapbook/ScrapbookNotes";
import ScrapbookVoice from "components/FrondDetails/Scrapbook/ScrapbookVoice";
import ScrapbookLinks from "components/FrondDetails/Scrapbook/ScrapbookLinks";
import People from "components/FrondDetails/People/People";
import TasklistTemplate from "components/FrondDetails/Tasklist/TasklistTemplate";
import AllTasks from "components/FrondDetails/Tasklist/AllTasks";
import ActiveTasks from "components/FrondDetails/Tasklist/PendingTasks";
import CompletedTasks from "components/FrondDetails/Tasklist/CompletedTasks";
import ArchivedTasks from "components/FrondDetails/Tasklist/ArchivedTasks";
import OverdueTasks from "components/FrondDetails/Tasklist/InProgressTasks";
import UpdatesTemplate from "components/FrondDetails/Updates/UpdatesTemplate";
import Discover from "components/DiscoverTab";
import ProjectDiscover from "components/FrondDetails/Discover/Discover";
import PrivacySettings from "components/FrondDetails/PrivacySettings/PrivacySettings";
import MyTasks from "components/MyTasks/MyTasks";
import ArchivedTasksPage from "components/MyTasks/ArchivedTasksPage";
import AuthContactUs from "components/AuthContactUs/AuthContactUs";
import CommunityLayout from "components/Community/CommunityLayout";
import DiscoverData from "components/DiscoverScreen/DiscoverData";
import Suggestions from "components/DiscoverScreen/Suggestions";
import DiscoverLayout from "components/DiscoverScreen/DiscoverLayout";
import ProfilePage from "components/Profile/ProfilePage";
import ScrapbookFiles from "components/FrondDetails/Scrapbook/ScrapbookFiles";
import ProtectedSettings from "components/ProtectedRoutes/ProtectedSettings";

import useClarity from "./hooks/useClarity";
import SharePage from "components/SharePage/SharePage";
import { algoliasearch } from "algoliasearch";
import { InstantSearch } from "react-instantsearch";
import ProfileOtp from "components/Profile/ProfileOtp";
import ProtectedUpdateEmail from "components/ProtectedRoutes/ProtectedUpdateEmail";
import ProtectedDiscover from "components/ProtectedRoutes/ProtectedDiscover";
import Library from "components/Library/Library";
import TravelInterests from "./components/FrondDetails/Discover/TravelInterests";
import FlightDetails from "components/FrondDetails/Discover/FlightCard/FlightDetails";
import FlightList from "components/FrondDetails/Discover/FlightCard/FlightList";
import HotelList from "components/FrondDetails/Discover/HotelCard/HotelList";
import ActivityList from "components/FrondDetails/Discover/ActivityCard/ActivityList";
import AdminDraftBlogs from "components/Blog/AdminDraftBlogs";
import ExploreComponent from "components/FrondDetails/Discover/Explore/ExploreComponent";
import { ExploreProvider } from "./Context/ExploreContext";
import { API_BASE_URL } from "./config/apiConfig";



  const searchClient = algoliasearch(
    "9TB01M7Y89",
    "8304d022b141c9e3bb0b9a53fe8feb81"
  );


export const App = () => {
  const { clerkUser, user } = useUser();
  const { session } = useClerk();
  axios.defaults.baseURL = API_BASE_URL;
  const isSignedIn = localStorage.getItem("token");
  const { setToken } = useContext(AuthContext);
  // useClarity();

// Replace your getData function with this:
const getData = async function () {
  try {
    if (user) {
      //console.log("Creating user session...");
      
      const response = await axios.post("/user", {
        name: user.fullName,
        email: user.primaryEmailAddress.emailAddress,
        password: user.id,
        img_url: user.imageUrl,
      });

      const authToken = response.data.response.data.token;
      localStorage.setItem("token", authToken);
      localStorage.setItem("user_email", user.primaryEmailAddress.emailAddress);
      setToken(authToken);
      
      axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
      // console.log("Login successful, token stored:", authToken);
    }
  } catch (error) {
    console.error("Auth error:", error);
    // Clear invalid token if exists
    localStorage.removeItem("token");
    setToken(null);
  }
};


  useEffect(() => {
    // checkAccess();

    getData();
  }, [user]);

  const { token } = useContext(AuthContext);

  // Set axios default Authorization header whenever token changes
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const authToken = token || storedToken;
    if (authToken) {
      axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
      //console.log('🔐 Axios Authorization header set');
    } else {
      delete axios.defaults.headers.common.Authorization;
    }
  }, [token]);

  const RouteLayout = ({ children }) => {
    const { token } = useContext(AuthContext);
    return token ? (
      <AuthLayout>{children}</AuthLayout>
    ) : (
      <Layout>{children}</Layout>
    );
  };

  const routes = createBrowserRouter([
    {
      path: "",
      element: <RouteLayout />,

      children: [
        {
          index: true,
          element: !isSignedIn ? (
            <ProtectedLogin>
              <Homepage />
            </ProtectedLogin>
          ) : (
            <ProtectedRoutes>
              <MyFronds />
            </ProtectedRoutes>
          ),
        },
        {
          path: "home",
          element: !isSignedIn ? (
            <ProtectedLogin>
              <HomeComponent />
            </ProtectedLogin>
          ) : (
            <ProtectedRoutes>
              <MyFronds />
            </ProtectedRoutes>
          ),
        },
        {
          path: "shared-fronds",
          element: (
            <ProtectedRoutes>
              <SharedFronds />
            </ProtectedRoutes>
          ),
        },
        {
          path: "my-fronds",
          element: (
            <ProtectedRoutes>
              <MyFronds />
            </ProtectedRoutes>
          ),
        },
        {
          path: "my-tasks",
          element: (
            <ProtectedRoutes>
              <MyTasks />
            </ProtectedRoutes>
          ),
        },
        {
          path: "my-tasks/archive",
          element: (
            <ProtectedRoutes>
              <ArchivedTasksPage />
            </ProtectedRoutes>
          ),
        },
        {
          path: "profile",
          element: (
            <ProtectedRoutes>
              <ProfilePage />
            </ProtectedRoutes>
          ),
        },
        {
          path: "invitations",
          element: (
            <ProtectedRoutes>
              <Invitations />
            </ProtectedRoutes>
          ),
        },
        {
          path: "frond",
          element: (
            <ProtectedRoutes>
              <DetailsTemplate />
            </ProtectedRoutes>
          ),
          children: [
            {
              index: true,
              element: (
                <ProtectedRoutes>
                  <AboutFrondDetails />
                </ProtectedRoutes>
              ),
            },
            {
              path: "about/:frondId",
              element: (
                <ProtectedRoutes>
                  <AboutFrondDetails />
                </ProtectedRoutes>
              ),
            },
            {
              path: "scrapbook",
              element: (
                <ProtectedRoutes>
                  <ScrapbookTemplate />
                </ProtectedRoutes>
              ),
              children: [
                {
                  index: true,
                  element: (
                    <ProtectedRoutes>
                      <ScrapbookImages />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "images/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <ScrapbookImages />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "files/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <ScrapbookFiles />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "notes/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <ScrapbookNotes />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "voice-memos/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <ScrapbookVoice />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "links/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <ScrapbookLinks />
                    </ProtectedRoutes>
                  ),
                },
              ],
            },
            {
              path: "people/:frondId",
              element: (
                <ProtectedRoutes>
                  <People />
                </ProtectedRoutes>
              ),
            },
            {
              path: "tasklist",
              element: (
                <ProtectedRoutes>
                  <TasklistTemplate />
                </ProtectedRoutes>
              ),
              children: [
                {
                  index: true,
                  element: (
                    <ProtectedRoutes>
                      <AllTasks />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "all/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <AllTasks />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "pending/:frondId",element: (<ProtectedRoutes> <ActiveTasks /></ProtectedRoutes> ), },
{
                  path: "completed/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <CompletedTasks />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "archived/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <ArchivedTasks />
                    </ProtectedRoutes>
                  ),
                },
                {
                  path: "in-progress/:frondId",
                  element: (
                    <ProtectedRoutes>
                      <OverdueTasks />
                    </ProtectedRoutes>
                  ),
                },
              ],
            },
            {
              path: "updates/:frondId",
              element: (
                <ProtectedRoutes>
                  <UpdatesTemplate />
                </ProtectedRoutes>
              ),
            },
        {
          path: "discover/:frondId",
          element: (
            <ProtectedRoutes>
              <ProtectedDiscover>
                <ProjectDiscover />
              </ProtectedDiscover>
            </ProtectedRoutes>
          ),
          children: [
            {
              path: "travel-interests",
              element: (
                <ProtectedRoutes>
                  <ProtectedDiscover>
                    <TravelInterests />
                  </ProtectedDiscover>
                </ProtectedRoutes>
              ),
            },
            {
              path: "flight-list",
              element: (
                <ProtectedRoutes>
                  <ProtectedDiscover>
                    <FlightList/>
                  </ProtectedDiscover>
                </ProtectedRoutes>
              ),
            },
            {
              path: "flight-details/:id",
              element: (
                <ProtectedRoutes>
                  <ProtectedDiscover>
                    <FlightDetails/>
                  </ProtectedDiscover>
                </ProtectedRoutes>
              ),
            },
{
              path: "hotel-list",
              element: (
                <ProtectedRoutes>
                  <ProtectedDiscover>
                    <HotelList/>
                  </ProtectedDiscover>
                </ProtectedRoutes>
              ),
            },
{
              path: "activity-list",
              element: (
                <ProtectedRoutes>
                  <ProtectedDiscover>
                    <ActivityList/>
                  </ProtectedDiscover>
                </ProtectedRoutes>
              ),
            },
            {
              path: "explore-places",
              element: (
                <ProtectedRoutes>
                  <ProtectedDiscover>
                    <ExploreComponent />
                  </ProtectedDiscover>
                </ProtectedRoutes>
              ),
            },
          ],
        },
             
            {
              path: "settings/:frondId",
              element: (
                <ProtectedRoutes>
                  <ProtectedSettings>
                    <PrivacySettings />
                  </ProtectedSettings>
                </ProtectedRoutes>
              ),
            },
          ],
        },
        {
          path: "archived-fronds",
          element: (
            <ProtectedRoutes>
              <ArchiveFronds />
            </ProtectedRoutes>
          ),
        },
        {
          path: "create-frond",
          element: (
            <ProtectedRoutes>
              <CreateFrond />
            </ProtectedRoutes>
          ),
        },
        {
          path: "community",
          element: (
            <ProtectedRoutes>
              <CommunityLayout />
            </ProtectedRoutes>
          ),
        },
        {
          path: "discover",
          element: (
            <ProtectedRoutes>
              <Discover />
            </ProtectedRoutes>
          ),
        },
        // {
        //   path: "discover",
        //   element: (
        //     <ProtectedRoutes>
        //       <DiscoverLayout />
        //     </ProtectedRoutes>
        //   ),
        //   children: [
        //     {
        //       index: true,
        //       element: (
        //         <ProtectedRoutes>
        //           <DiscoverData />
        //         </ProtectedRoutes>
        //       ),
        //     },
        //     {
        //       path: "options",
        //       element: (
        //         <ProtectedRoutes>
        //           <DiscoverData />
        //         </ProtectedRoutes>
        //       ),
        //     },
        //     {
        //       path: "suggestions",
        //       element: (
        //         <ProtectedRoutes>
        //           <Suggestions />
        //         </ProtectedRoutes>
        //       ),
        //     },
        //     {
        //       path: "suggestions/:searchOption",
        //       element: (
        //         <ProtectedRoutes>
        //           <Suggestions />
        //         </ProtectedRoutes>
        //       ),
        //     },
        //   ],
        // },
        {
          path: "login",
          element: (
            <ProtectedLogin>
              <Login />
            </ProtectedLogin>
          ),
        },
        {
          path: "signup",
          element: (
            <ProtectedLogin>
              <Register />
            </ProtectedLogin>
          ),
        },
        {
          path: "forget-password",
          element: (
            <ProtectedLogin>
              <ForgetPassword />
            </ProtectedLogin>
          ),
        },
        {
          path: "reset-password",
          element: (
            <ProtectedLogin>
              <ProtectedReset>
                <ResetPassword />
              </ProtectedReset>
            </ProtectedLogin>
          ),
        },
        {
          path: "verify-password",
          element: (
            <ProtectedLogin>
              <ProtectedVerify>
                <VerifyPassword />
              </ProtectedVerify>
            </ProtectedLogin>
          ),
        },
    
       
        {
          path: "library",
          element: (
            <ProtectedRoutes>
              <Library />
            </ProtectedRoutes>
          ),
        },
        {
          path: "contact-us",
          element: !isSignedIn ? (
            <ProtectedLogin>
              <ContactUs />
            </ProtectedLogin>
          ) : (
            <ProtectedRoutes>
              <AuthContactUs />
            </ProtectedRoutes>
          ),
        },
    {
          path: "/blogs",
          element: (
            <ProtectedRoutes>
              <Blog />
            </ProtectedRoutes>
          ),
        },
       {
          path: "blogs/:slug",
          element: <BlogPost />,
        },
        {
          path: "admin/blog",
          element: (
            <ProtectedRoutes>
              <AdminBlogManage />
            </ProtectedRoutes>
          ),
        },
        {
          path: "admin/blog/edit/:id",
          element: (
            <ProtectedRoutes>
              <AdminBlogManage />
            </ProtectedRoutes>
          ),
        },
        {
          path: "admin/blog/create",
          element: (
            <ProtectedRoutes>
              <AdminCreatePost />
            </ProtectedRoutes>
          ),
        },
        {
          path: "/admin/blog/drafts",
          element: (
            <ProtectedRoutes>
              <AdminDraftBlogs />
            </ProtectedRoutes>
          ),
        },
        
        {
          path: "faq",
          element: (
            <ProtectedLogin>
              <FAQ />
            </ProtectedLogin>
          ),
        },
        {
          path: "server-error",
          element: (
            <ProtectedError>
              <Error500 />
            </ProtectedError>
          ),
        },
        {
          path: "loading",
          element: <MainLoader />,
        },
        {
          path: "sso-callback",
          element: <MainLoader />,
        },
        {
          path: "sso-callback#_=_",
          element: <MainLoader />,
        },
        {
          path: "*",
          element: <Error404 />,
        },
      ],
    },
    {
      path: "share/frond/:frondSlug",
      element: <SharePage />,
    },
    {
      path: "verify-email",
      element: (
        <ProtectedRoutes>
          <ProtectedUpdateEmail>
            <ProfileOtp />
          </ProtectedUpdateEmail>
        </ProtectedRoutes>
      ),
    },
  ], {
  future: {
    v7_relativeSplatPath: true, // Add this future flag
    v7_startTransition: true,   // Also add this if you see the other warning
  },
});

  return (
    <>
      <InstantSearch searchClient={searchClient} indexName="general">
        <ExploreProvider token={token}>
          <NextUIProvider locale="en-GB">
            <RouterProvider router={routes}></RouterProvider>
          </NextUIProvider>
        </ExploreProvider>
      </InstantSearch>
    </>
  );
};

/*

const clerkUser = useUser();

    const {getToken, isSignedIn} = useAuth();
    const [selected, setSelected] = React.useState("myFronds");
    const {pathname} = useLocation();

    const db = getFirestore();

    const RouteWithSidebar = ({component: Component, ...rest}) => {
        const [loaded, setLoaded] = React.useState(false);
        React.useEffect(() => {
            const timer = setTimeout(() => setLoaded(true), 4000);
            return () => clearTimeout(timer);
        }, []);
        return (
            <Route
                {...rest}
                render={props => (
                    <>
                        <Layout>
                            {!loaded ? (
                                <Loader/>
                            ) : (
                                <>
                                    <Header/>

                                    <Component {...props} />
                                </>
                            )}
                        </Layout>
                    </>
                )}
            />
        );
    };

    const RouteFullPage = ({component: Component, ...rest}) => {
        const [loaded, setLoaded] = React.useState(false);

        React.useEffect(() => {
            const timer = setTimeout(() => setLoaded(true), 4000);
            return () => clearTimeout(timer);
        }, []);
        // console.log(loaded);
        return (
            <Route
                {...rest}
                render={props => (
                    <>
                        <Layout>
                            {!loaded ? (
                                <Loader/>
                            ) : (
                                <>
                                    <Component {...props} />
                                </>
                            )}
                        </Layout>
                    </>
                )}
            />
        );
    };

    useEffect(() => {
        axios.defaults.baseURL = API_BASE_URL;
        const getData = async function () {
            try {
                // const firebaseToken = clerkUser.user.getSessions();
                const auth = getAuth();

                const token = await getToken({template: "integration_firebase"});
                const userCredentials = await signInWithCustomToken(auth, token);
                if (clerkUser.isSignedIn) {
                    axios
                        .post("/user", {
                            name: clerkUser.user.fullName,
                            email: clerkUser.user.primaryEmailAddress.emailAddress,
                            password: clerkUser.user.id,
                        })
                        .then(res => {
                            const authToken = res.data.response.data.token;
                            localStorage.setItem("token", authToken);
                            localStorage.setItem(
                                "user_email",
                                clerkUser.user.primaryEmailAddress.emailAddress,
                            );
                            setToken(authToken);
                            axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
                        })
                        .catch(err => {
                            // console.log(err.response.data.errors);
                        });
                }
            } catch (err) {
                // console.log(err);
            }
        };

        getData();
    }, [clerkUser]);
    // console.log(pathname);
    return (
        <NextUIProvider>
            <ChakraProvider>
                {!isSignedIn ? <Header/> : <AuthNavbar/>}
                {isSignedIn && (
                    <Tabs
                        aria-label="Tabs"
                        selectedKey={pathname}
                        classNames={{
                            cursor: "w-full bg-primaryBlue ",
                            tabContent:
                                "group-data-[selected=true]:text-[#fff] group-data-[selected=false]:text-[#2B2B2A]",
                            base: "sticky top-0",
                        }}
                        variant="light"
                        size="lg"
                        fullWidth
                        radius="lg"
                    >
                        <Tab
                            key="/"
                            id="/"
                            as={Link}
                            href="/"
                            title={
                                <div className="flex items-center space-x-2">
                                    <Target/>

                                    <span>My fronds</span>
                                </div>
                            }
                        />
                        <Tab
                            key="/createfrond"
                            id="/createfrond"
                            href="/createfrond"
                            title={
                                <div className="flex items-center space-x-2">
                                    <SquarePen/>

                                    <span>Create a frond</span>
                                </div>
                            }
                        />
                        <Tab
                            key="sharedFronds"
                            title={
                                <div className="flex items-center space-x-2">
                                    <Share2/>

                                    <span>Shared fronds</span>
                                </div>
                            }
                        />
                        <Tab
                            key="archivedFronds"
                            title={
                                <div className="flex items-center space-x-2">
                                    <ArchiveX/>

                                    <span>Archived fronds</span>
                                </div>
                            }
                        />
                        <Tab
                            key="invitations"
                            title={
                                <div className="flex items-center space-x-2">
                                    <UserPlus/>

                                    <span>Invitations</span>
                                </div>
                            }
                        />
                        <Tab
                            key="discover"
                            title={
                                <div className="flex items-center space-x-2">
                                    <Target/>

                                    <span>Discover</span>
                                </div>
                            }
                        />
                        <Tab
                            key="community"
                            title={
                                <div className="flex items-center space-x-2">
                                    <Users/>

                                    <span>Community</span>
                                </div>
                            }
                        />
                    </Tabs>
                )}
                <Switch>
                    {isSignedIn ? (
                        <>
                            {/* <RouteFullPage
                  component={Dashboard}
                  path={Routes.Home.path}
                  exact
                /> }
                <RouteFullPage component={MyFrond} path={"/"} exact/>
                <RouteFullPage
                    component={CreateAFrond}
                    path={"/createfrond"}
                    exact
                />
            </>
        ) : (
            <>
                <RouteFullPage
                    component={Homepage}
                    path={Routes.Home.path}
                    exact
                />
                <RouteFullPage
                    component={Workpage}
                    path={Routes.Work.path}
                    exact
                />
                <RouteFullPage
                    component={Celebratepage}
                    path={Routes.Celebrate.path}
                    exact
                />
                <RouteFullPage
                    component={Pricingpage}
                    path={Routes.Pricing.path}
                    exact
                />
                <RouteFullPage
                    component={Contactpage}
                    path={Routes.Contact.path}
                    exact
                />
                <RouteFullPage
                    component={Escapepage}
                    path={Routes.Escape.path}
                    exact
                />
                <RouteFullPage
                    component={Homeplaning}
                    path={Routes.Homeplaning.path}
                    exact
                />
            </>
        )}
    </Switch>
</ChakraProvider>
</NextUIProvider>
);
*/
